import React from 'react';
import classNames from 'classnames';
import {getDayMonthFromDate} from '../analyticsUtils';

function AverageHeader({reportType, label}) {
  return (
    <div className="day-header">
      <div>{reportType === 'time-spend' ? 'Total' : label}</div>
    </div>
  )
}

function AverageScore({avgField, getAvgCellValue, getAvgBackgroundColor}) {
  if (avgField && getAvgCellValue(avgField)) {
    return (
      <div
        className="score"
        style={{backgroundColor: getAvgBackgroundColor(avgField)}}
      >
        {getAvgCellValue(avgField)}
      </div>
    )
  }

  return (
    <div className="score" style={{backgroundColor: '#eee'}}>
      N/R
    </div>
  )
}

export function OpenedDayAverageColumn({
  reportAnalytics,
  displayedQuestions,
  openedDay,
  getAvgPerDay,
  closeOpenedDay,
}) {
  return (
    <div className={classNames('day')}>
      <div className="reports">
        <div className="report">
          <div className="day-header">
            <div onClick={closeOpenedDay}>{getDayMonthFromDate(openedDay.day)} X</div>
          </div>
          <div className="day-header">
            <div>Avg</div>
          </div>
          {displayedQuestions.map(question => (
            <div className="score" style={{backgroundColor: '#eee'}} key={question}>
              {getAvgPerDay(reportAnalytics.reportMap[`${openedDay.phaseGuid}${openedDay.week}${openedDay.day}`], question)}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export function WeekAverageColumn({
  reportAnalytics,
  phase,
  week,
  displayedQuestions,
  reportType,
  getAvgCellValue,
  getAvgBackgroundColor,
  getTotalTimeSpend,
  timeConvert,
}) {
  return (
    <div className={classNames('day')}>
      <div className="reports">
        <div className="report">
          <div className="day-header">
            <div>Week</div>
          </div>
          <AverageHeader reportType={reportType} label="Avg"/>
          {displayedQuestions.map(question => (
            <AverageScore
              key={question}
              avgField={reportAnalytics.weeklyAvgMap[`${phase.guid}#${question}#${week.weekNumber}`]}
              getAvgCellValue={getAvgCellValue}
              getAvgBackgroundColor={getAvgBackgroundColor}
            />
          ))}
          <div className="score" key="time-spend-summary">
            {timeConvert(getTotalTimeSpend(displayedQuestions, reportAnalytics.weeklyAvgMap, phase.guid, week.weekNumber))}
          </div>
        </div>
      </div>
    </div>
  )
}

export function PhaseAverageColumn({
  reportAnalytics,
  phase,
  displayedQuestions,
  reportType,
  openedDay,
  getAvgCellValue,
  getAvgBackgroundColor,
  getPhaseTotalTimeSpend,
  timeConvert,
}) {
  return (
    <div className="week">
      {!openedDay && <div className="week-header">#</div>}
      <div className="days">
        <div className={classNames('day')}>
          <div className="reports">
            <div className="report">
              <div className="day-header">
                <div>Phase</div>
              </div>
              <AverageHeader reportType={reportType} label="Avg"/>
              {displayedQuestions.map(question => (
                <AverageScore
                  key={question}
                  avgField={reportAnalytics.phaseAvgMap[`${phase.guid}#${question}#`]}
                  getAvgCellValue={getAvgCellValue}
                  getAvgBackgroundColor={getAvgBackgroundColor}
                />
              ))}
              <div className="score" key="time-spend-summary">
                {timeConvert(getPhaseTotalTimeSpend(displayedQuestions, reportAnalytics.phaseAvgMap, phase.guid))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function ProgramAverageColumn({
  reportAnalytics,
  displayedQuestions,
  reportType,
  openedDay,
  getAvgCellValue,
  getProgramTotalTimeSpend,
  timeConvert,
}) {
  return (
    <div className="phase">
      <div className="phase-header">#</div>
      <div className="weeks">
        <div className="week">
          {!openedDay && <div className="week-header">#</div>}
          <div className="days">
            <div className={classNames('day')}>
              <div className="reports">
                <div className="report">
                  <div className="day-header">
                    <div>Program</div>
                  </div>
                  <AverageHeader reportType={reportType} label="Avg"/>
                  {displayedQuestions.map(question => (
                    reportAnalytics.totalAvgMap[`#${question}#`] && getAvgCellValue(reportAnalytics.totalAvgMap[`#${question}#`]) ?
                      (<div className="score" key={question}>
                        {getAvgCellValue(reportAnalytics.totalAvgMap[`#${question}#`])}
                      </div>)
                      : (<div className="score" key={question}>N/R</div>)
                  ))}
                  <div className="score" key="time-spend-summary">
                    {timeConvert(getProgramTotalTimeSpend(displayedQuestions, reportAnalytics.totalAvgMap))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
